module.exports = {"510183001":"文君街道","510183002":"临邛街道","510183003":"固驿街道","510183004":"羊安街道","510183005":"高埂街道","510183006":"孔明街道","510183103":"桑园镇","510183104":"平乐镇","510183105":"夹关镇","510183106":"火井镇","510183115":"临济镇","510183118":"天台山镇","510183121":"南宝山镇","510183122":"大同镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510183.json
// module id = 2402
// module chunks = 0